import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["options"]

  connect() {
    console.log("Question controller connected")
  }

  selectAnswer(event) {
    const questionId = event.target.dataset.questionId
    const answerId = event.target.value

    // Update the hidden form fields
    const form = document.getElementById("answer-form")
    const questionIdField = document.getElementById("question-id-field")
    const answerIdField = document.getElementById("answer-id-field")

    questionIdField.value = questionId
    answerIdField.value = answerId

    // Submit the form with Turbo (let Turbo handle the submission)
    form.requestSubmit()
  }

  toggleFlag(event) {
    const button = event.currentTarget
    const questionId = button.dataset.questionId
    const currentlyFlagged = button.dataset.flagged === "true"
    const newFlaggedValue = !currentlyFlagged

    // Update the hidden form fields
    const form = document.getElementById("flag-form")
    const questionIdField = document.getElementById("flag-question-id-field")
    const flagValueField = document.getElementById("flag-value-field")

    questionIdField.value = questionId
    flagValueField.value = newFlaggedValue

    // Submit the form with Turbo (let Turbo handle the submission)
    form.requestSubmit()
  }
}